.breadcrumb a,
.breadcrumb h1 {
  font-size: 20px !important;
  @media (max-width: 640px) {
    font-size: 16px !important;
  }
}

.header {
  display: flex;
  align-items: center;
  h1 {
    margin-right: 4px;
  }
}
